import CascateList from "../../../../../../common/components/cascate_list";
import { useCallback } from "react";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import { DropDown } from "../../../../../../common/domain/models/dropdown";
import DefaultInput from "../../../../../../common/components/default_input";
import { DefaultAutocomplete } from "../../../../../../common/components/default_autocomplete";

/**
 * Header Checklist Entrega Lista.
 * 
 */

type Props = {
  codigo?: string;
  descricao?: string;
  status?: number;


  onClearFilters: () => void;
  handleCodigoChange: (novoCodigo: string | null) => void;
  handleDescricaoChange: (novaDescricao: string | null) => void;
  handleStatusChange: (novoStatus: number | null) => void;
};


export const Header = ({
  codigo,
  descricao,
  status,
  handleCodigoChange,
  handleDescricaoChange,
  onClearFilters,
  handleStatusChange,


}: Props) => {

  const handleClearFilters = useCallback(() => {
    onClearFilters();
  }, [onClearFilters]);

  const ddlStatus: DropDown[] = [
    { id: 2, title: 'Todos' },
    { id: 0, title: 'Ativo' },
    { id: 1, title: 'Inativo' },
  ];


  return (
    <>
      <CascateList
        title="Filtros"
        defaultOpen>
        <div className="w-full flex flex-col gap-6 items-center justify-center">
          <div className="w-full grid gap-6 grid-cols-2 md:grid-cols-2 lg:grid-cols-2 grid-flow-row-dense">

            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1 " >
              <div className="w-[40%]">
                <DefaultInput
                  name='codigo'
                  label='Codigo'
                  value={codigo}
                  onChangeValue={handleCodigoChange}
                />
              </div>

              <div className="w-[40%]">
                <DefaultInput
                  name='descricao'
                  label='Descrição'
                  value={descricao}
                  onChangeValue={handleDescricaoChange}
                />
              </div>


              <div className="w-[20%]">
                <DefaultAutocomplete
                  label='Status'
                  value={ddlStatus.find(x => x.id === status) ?? null}
                  options={ddlStatus}
                  getOptionLabel={x => x.title}
                  getOptionKey={x => x.id}
                  onChange={x => handleStatusChange(x?.id ?? null)} />
              </div>

            </div>



            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1 justify-end">
              <div className="w-[180px]">
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                  buttonColor="yellow"
                  onClick={handleClearFilters}>
                  Limpar filtros
                </PrimaryButton>
              </div>
            </div>

          </div>
        </div>

      </CascateList>
    </>
  );
}